<table class="table table-striped" [class.rows-clickable]="rowsClickable" *ngIf="isRegistries">
    <thead>
        <tr>
            <th *ngFor="let entry of headers">
                <span>{{ entry.name }}</span>
                <span
                    *ngIf="entry.sort_id"
                    class="sort"
                    [ngClass]="{
                        'sort--asc': order.id === entry.sort_id && order.type === 'asc',
                        'sort--desc': order.id === entry.sort_id && order.type === 'desc'
                    }"
                >
                    <i class="fa fa-sort-asc" (click)="onOrderChange(entry, 'desc')"></i>
                    <i class="fa fa-sort-desc" (click)="onOrderChange(entry, 'asc')"></i>
                    <i class="fa fa-sort" (click)="onOrderChange(entry, 'desc')"></i>
                </span>
            </th>
            <th *ngIf="publicView"></th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let record of registries" (click)="onRowClicked(record)">
            <td *ngFor="let field of record.rows" [class.dropDown]="field.type === 'onDemandPsvMessage'">
                <ng-container *ngIf="!field.type">
                    <span
                        class="cm-link"
                        (click)="showHistory(record, field.historyStepType)"
                        *ngIf="field.historyStepType && field.value; else displayHtml"
                        >{{ findAndReplaceLinks(field.value || 'N/A') }}</span
                    >
                    <ng-template #displayHtml>
                        <cm-display-html [content]="findAndReplaceLinks(field.value || 'N/A')"></cm-display-html
                    ></ng-template>
                </ng-container>
                <ng-container *ngIf="field.type">
                    <ng-container [ngSwitch]="field.type">
                        <cm-attachments-popover
                            *ngSwitchCase="'attachment'"
                            [attachments]="field.value"
                            (skipNextRowClick)="onSkipNextRowClick()"
                        >
                        </cm-attachments-popover>
                        <ng-container *ngIf="!publicView && showDemandPsv">
                            <div (click)="onSkipNextRowClick()" class="psv-button-wrapper">
                                <cm-on-demand-psv-button
                                    [buttonField]="field"
                                    [registry]="record"
                                    (initPsv)="initiatePsv($event)"
                                ></cm-on-demand-psv-button>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </td>
            <td *ngIf="publicView">
                <button type="button" class="btn btn-primary" (click)="viewDetails.emit(record)">View Details</button>
            </td>
            <ng-container *ngIf="!publicView">
                <td class="link-wrapper" (click)="showHistory(record)">
                    <div class="message-button">
                        <span
                            container="body"
                            placement="top"
                            tooltipClass="max-200 text-left"
                            [ngbTooltip]="
                                record.lastVerifiedDate
                                    ? 'Last Verified: ' + (record.lastVerifiedDate | date: 'mediumDate')
                                    : ''
                            "
                            >History</span
                        >
                    </div>
                </td>
            </ng-container>
        </tr>
    </tbody>
</table>
<cm-no-content *ngIf="!isRegistries" class="no-content" [config]="noContentConfig"></cm-no-content>
